'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/.15.4.2@react/react.js
// module id = 1
// module chunks = 0